import { SeatFlatIcon } from './SeatFlatIcon';

/**
 * author: Google
 * id FDDF112E-DFF5-4D31-9821-69902F92E6CF
 * name seat-flat
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-flat.svg
 * tags
 */
export const AirlineSeatFlatIcon = SeatFlatIcon;
export default AirlineSeatFlatIcon